// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduler-container {
  margin: 20px;
  position: relative;
  z-index: 1; /* Add this line */
}
.fc2 {
  margin: 100px 50px;
}
.quill-container {
  width: 600px; /* Set the desired width */
  max-width: 100%; /* Ensure it doesn't exceed the parent container */
}

/* Adjust the height if necessary */
.ql-editor {
  height: 200px; /* Set the desired height */
}

/* Optionally adjust font size, padding, and other styles */
.ql-editor p {
  font-size: 14px;
  margin: 5px 0;
}
.custom-scheduler-container {
  width: 100%; /* Adjust the width as needed */
  position: relative;

  z-index: 0; /* Add this line */
}
.date-picker {
  z-index: 99999;
}

.fc {
  font-family: Arial, sans-serif;
  background-color: #fafafa;
  padding: 20px;
  border-radius: 8px;
  max-width: 100%;
  box-sizing: border-box;
  margin-right: 10px;
}
.fc-timegrid-slot-lane {
  background-color: white;
}

.fc-theme-standard .fc-scrollgrid {
  min-width: 800px;
}

.fc-event {
  background-color: transparent;
  border: none;
  color: white;
}

.custom-event {
  display: flex;
  flex-direction: column;
  background-color: #ffffff; /* Adjust background color as needed */
  border: 1px solid #d1d9e2;
  border-radius: 4px;
  padding: 5px;
  margin: 5px;
}

.event-time {
  font-weight: bold;
  text-align: center;
}

.event-title {
  text-align: center;
}
.fc .fc-col-header-cell-cushion {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px; /* Adjust font size as needed */
}

.fc-theme-standard .fc-scrollgrid {
  border: none;
}

.fc-theme-standard td:first-child {
  border: none;
}

td.fc-day-mon.fc-day-future.fc-timegrid-col,
td.fc-day-tue.fc-day-future.fc-timegrid-col,
td.fc-day-wed.fc-day-future.fc-timegrid-col,
td.fc-day-thu.fc-day-future.fc-timegrid-col,
td.fc-day-fri.fc-day-future.fc-timegrid-col {
  background-color: #fff;
}

.fc-theme-standard td,
.fc-theme-standard th {
  border: 0.5px solid #ddd;
}

.fc .fc-day-header {
  text-transform: uppercase; /* Convert text to uppercase */
  font-weight: bold; /* Make the text bold */
}

.fc .fc-button:disabled {
  background-color: #fafafa;
  color: black;
  font-weight: 600;
}

/* Style the buttons in the FullCalendar header */
.fc-toolbar .fc-button {
  background-color: #fafafa; /* Background color */
  color: #71717a; /* Text color */
  border-color: #fff; /* Border color */ /* Transition for hover and click */
  border-radius: 8px;
  margin-right: 5px;
  border: none;
}

.fc-toolbar .fc-button::first-letter {
  text-transform: uppercase;
}

.fc-event:hover {
  background-color: #cb9c2d; /* Set the desired background color on hover */
  color: white; /* Set the desired text color on hover */
  border-color: #cb9c2d; /* Set the desired border color on hover */
}

.fc-list-event-time,
.fc-list-event-graphic {
  display: none;
}
.fc .fc-popover {
  z-index: 999 !important;
}
.fc .fc-list-event:hover td {
  background-color: #cb9c2d !important; /* Set the desired background color on hover */
  color: white !important; /* Set the desired text color on hover */
  border-color: #cb9c2d !important; /* Set the desired border color on hover */
}

.fc-dayGridMonth-button.fc-button.fc-button-primary.fc-button-active {
  background-color: #cb9c2d; /* Selected background color */
  color: white; /* Selected text color */
  border-radius: 8px;
  border: none;
}
.fc-timeGridWeek-button.fc-button.fc-button-primary.fc-button-active {
  background-color: #cb9c2d; /* Selected background color */
  color: white; /* Selected text color */
  border-radius: 8px;
  border: none;
}
.fc-timeGridDay-button.fc-button.fc-button-primary.fc-button-active {
  background-color: #cb9c2d; /* Selected background color */
  color: white; /* Selected text color */
  border-radius: 8px;
  border: none;
}
.fc-listMonth-button.fc-button.fc-button-primary.fc-button-active {
  background-color: #cb9c2d; /* Selected background color */
  color: white; /* Selected text color */
  border-radius: 8px;
  border: none;
}

.fc .fc-toolbar-title {
  color: #5f6d7e;
  font-weight: 600;
  font-size: 22px;
}
.fc-toolbar .fc-button:hover {
  background-color: #e6e6e6;
  color: black;
}

.event-dot {
  display: flex;
  align-items: center;
}

.dot {
  width: 8px;
  height: 8px;
  background-color: red;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 500;
  font-family: "Source Sans Pro, sans-serif";
}

.event-dot span {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-left: 4px;
}

.tooltip {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  /* padding: 10px; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 9999; /* Set a high z-index value to bring the tooltip to the forefront */
  font-family: "Source Sans Pro, sans-serif";
  font-size: 14px;
  display: none;
  margin-top: 30px;
  margin-left: 20px;
}

/* Add styles for the rows and dots within the tooltip */
.tooltip .row {
  display: flex;
  align-items: center;
  margin: 5px 0;
  color: #4d4e4e;
  font-weight: 600;
  font-size: 16px;
}

.tooltip .dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 10px;
}

.tooltip .title {
  font-weight: 600;
  font-size: 16px;
  margin-top: -4px;
  color: #4d4d4d;
}

.rbc-allday-cell {
  display: none;
}
.rbc-row-resource {
  height: 40px;
}
.rbc-row-resource .rbc-header {
  font-size: 18px;
  margin-top: 7px;
}

.rbc-current-time-indicator {
  border: none !important;
  background-color: transparent !important;
}
.rbc-timeslot-group {
  background-color: #ffffff;
}
/* Sample CSS for styling the custom DatePicker component */
.custom-date-picker {
  width: 200px; /* Adjust the width as needed */
}

.custom-input {
  display: flex;
  align-items: center;
}

.custom-date-input {
  flex: 1 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  color: #5f6d7e;
  font-weight: 500;
}

.calendar-icon {
  margin-left: 8px;
  cursor: pointer;
  color: #5f6d7e;
  font-size: 16px;
}

/* DatePicker styles */
.react-datepicker {
  font-family: "Arial, sans-serif";
}
.custom-calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #ffffff; /* Adjust background color as needed */
  border-bottom: 1px solid #d1d9e2; /* Add a border at the bottom */
}

.custom-calendar-title {
  font-weight: bold;
  font-size: 20px; /* Adjust font size as needed */
  color: #5f6d7e;
  font-weight: 600;
}

.custom-calendar-buttons button {
  background-color: #f4f4f5;
  border: none;
  cursor: pointer;
  margin-left: 10px;
  transition: color 0.3s ease;
}

.default-btn {
  width: 120px;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  height: 35px;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.016px;
  background: #cb9c2d;
  color: #fff;
  margin-top: 20px;
}

.default-btn:hover {
  background-color: #9b7725;
}

.default-city-container {
  margin-bottom: 20px;
}

.calendar-sidebar-container {
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 270px;
}

.option-container {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 5px;
}

.default-city-option {
  appearance: none;
  background-color: transparent;
  border: 1px solid #cb9c2d;
  border-radius: 50%;
  cursor: pointer;
  height: 16px;
  margin: 0px;
  padding: 0px;
  position: relative;
  width: 16px;
}

.default-city-option:checked {
  background-color: transparent;
}
.default-city-option:checked::before {
  background-color: #cb9c2d;
  border-radius: 64px;
  content: "";
  height: 12px;
  position: absolute;
  width: 12px;
  top: 1.5px;
  left: 1px;
}

.date-select-calendar {
  background-color: #ffffff;
  border-color: #f2f0f0;
  border-width: 2px;
  border-style: solid;
  font-size: 16px;
  font-weight: 400;
  color: #3c4147;
  font-family: Inter;
  border-radius: 4px;
  padding: 5px 10px;
  height: 38px;
  border: 1px solid #c1c6cc;
  box-shadow: none;
  box-sizing: border-box;
}

.busyWrapper {
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgb(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
}

.busyContainer {
  width: 50%;
  height: 85vh;
  background-color: #ffffff;
  border-radius: 16px;
  padding: 20px 40px;
  box-sizing: border-box;
}

.modalContent {
  height: calc(100% - 100px);
  box-sizing: border-box;
}

.busyBtn {
  height: 100px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btnOk {
  height: 50px;
  width: 200px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-family: "Inter";
  font-weight: 600;
  line-height: 22px;
  cursor: pointer;
  color: #ffffff;
  background-color: #cb9c2d;
  box-sizing: border-box;
}

.btnOk:hover {
  background-color: #b08726;
}

.busyItem {
  font-size: 15px;
  font-family: "Inter";
  font-weight: 500;
  line-height: 22px;
  cursor: pointer;
  color: #373636;
  height: 40px;
  width: 100%;
  box-shadow: 0px 0px 30px 5px rgba(95, 109, 126, 0.1);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 10px;
  border-radius: 6px;
  box-sizing: border-box;
}

.busyContent {
  padding: 10px 0px;
}

.busyTitle {
  width: 100%;
  text-align: center;
  font-family: "Inter";
  font-weight: 600;
  font-size: 32px;
  color: #4d4d4d;
}

.loadingContainer {
  height: 150vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000000;
}

@media screen and (max-width: 1300px) {
  .sidebar-box {
    flex-direction: column;
    margin-top: 70px !important;
  }
  .calendar-sidebar-container {
    flex-direction: row;
    width: auto;
    gap: 16px;
  }
  .selectCal {
    min-width: 150px;
  }
}

@media screen and (max-width: 950px) {
  .fc .fc-view-harness {
    overflow: scroll;
  }
  .fc2 {
    margin: 50px 0px;
  }
}

@media screen and (max-width: 800px) {
  .fc .fc-toolbar {
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    row-gap: 15px;
  }

  .fc-toolbar .fc-toolbar-chunk {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .fc .fc-toolbar .fc-toolbar-chunk:first-child {
    grid-column: 2 / 3;
    grid-row: 1/2;
  }
  .fc .fc-toolbar .fc-toolbar-chunk:nth-child(2) {
    grid-column: 1 / 2;
    grid-row: 1/2;
  }
  .fc-toolbar .fc-toolbar-chunk:last-child {
    grid-column: 1 / 3;
    grid-row: 2/3;
  }
  .fc-toolbar-chunk:last-child .fc-button-group {
    gap: 60px;
  }
}

@media screen and (max-width: 660px) {
  .fc-toolbar-chunk:last-child .fc-button-group {
    gap: 40px;
  }
}

@media screen and (max-width: 540px) {
  .fc-toolbar-chunk:last-child .fc-button-group {
    gap: 25px;
  }

  .fc .fc-toolbar-title {
    font-size: 16px;
  }
  .fc .fc-button {
    font-size: 14px;
  }
}

@media screen and (max-width: 430px) {
  .fc-toolbar-chunk:last-child .fc-button-group {
    gap: 25px;
  }
  .fc .fc-toolbar-title {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/calendarIpd/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU,EAAE,kBAAkB;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY,EAAE,0BAA0B;EACxC,eAAe,EAAE,kDAAkD;AACrE;;AAEA,mCAAmC;AACnC;EACE,aAAa,EAAE,2BAA2B;AAC5C;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,WAAW,EAAE,+BAA+B;EAC5C,kBAAkB;;EAElB,UAAU,EAAE,kBAAkB;AAChC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB,EAAE,sCAAsC;EACjE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe,EAAE,+BAA+B;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,iBAAiB,EAAE,uBAAuB;AAC5C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,yBAAyB,EAAE,qBAAqB;EAChD,cAAc,EAAE,eAAe;EAC/B,kBAAkB,EAAE,iBAAiB,EAAE,mCAAmC;EAC1E,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,8CAA8C;EACzE,YAAY,EAAE,wCAAwC;EACtD,qBAAqB,EAAE,0CAA0C;AACnE;;AAEA;;EAEE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC,EAAE,8CAA8C;EACpF,uBAAuB,EAAE,wCAAwC;EACjE,gCAAgC,EAAE,0CAA0C;AAC9E;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,YAAY,EAAE,wBAAwB;EACtC,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,YAAY,EAAE,wBAAwB;EACtC,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,YAAY,EAAE,wBAAwB;EACtC,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,YAAY,EAAE,wBAAwB;EACtC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa,EAAE,mEAAmE;EAClF,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;AAC1C;AACA;EACE,yBAAyB;AAC3B;AACA,2DAA2D;AAC3D;EACE,YAAY,EAAE,+BAA+B;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB,EAAE,sCAAsC;EACjE,gCAAgC,EAAE,+BAA+B;AACnE;;AAEA;EACE,iBAAiB;EACjB,eAAe,EAAE,+BAA+B;EAChD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,WAAW;EACX,oDAAoD;EACpD,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,2BAA2B;IAC3B,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".scheduler-container {\n  margin: 20px;\n  position: relative;\n  z-index: 1; /* Add this line */\n}\n.fc2 {\n  margin: 100px 50px;\n}\n.quill-container {\n  width: 600px; /* Set the desired width */\n  max-width: 100%; /* Ensure it doesn't exceed the parent container */\n}\n\n/* Adjust the height if necessary */\n.ql-editor {\n  height: 200px; /* Set the desired height */\n}\n\n/* Optionally adjust font size, padding, and other styles */\n.ql-editor p {\n  font-size: 14px;\n  margin: 5px 0;\n}\n.custom-scheduler-container {\n  width: 100%; /* Adjust the width as needed */\n  position: relative;\n\n  z-index: 0; /* Add this line */\n}\n.date-picker {\n  z-index: 99999;\n}\n\n.fc {\n  font-family: Arial, sans-serif;\n  background-color: #fafafa;\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 100%;\n  box-sizing: border-box;\n  margin-right: 10px;\n}\n.fc-timegrid-slot-lane {\n  background-color: white;\n}\n\n.fc-theme-standard .fc-scrollgrid {\n  min-width: 800px;\n}\n\n.fc-event {\n  background-color: transparent;\n  border: none;\n  color: white;\n}\n\n.custom-event {\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff; /* Adjust background color as needed */\n  border: 1px solid #d1d9e2;\n  border-radius: 4px;\n  padding: 5px;\n  margin: 5px;\n}\n\n.event-time {\n  font-weight: bold;\n  text-align: center;\n}\n\n.event-title {\n  text-align: center;\n}\n.fc .fc-col-header-cell-cushion {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 16px; /* Adjust font size as needed */\n}\n\n.fc-theme-standard .fc-scrollgrid {\n  border: none;\n}\n\n.fc-theme-standard td:first-child {\n  border: none;\n}\n\ntd.fc-day-mon.fc-day-future.fc-timegrid-col,\ntd.fc-day-tue.fc-day-future.fc-timegrid-col,\ntd.fc-day-wed.fc-day-future.fc-timegrid-col,\ntd.fc-day-thu.fc-day-future.fc-timegrid-col,\ntd.fc-day-fri.fc-day-future.fc-timegrid-col {\n  background-color: #fff;\n}\n\n.fc-theme-standard td,\n.fc-theme-standard th {\n  border: 0.5px solid #ddd;\n}\n\n.fc .fc-day-header {\n  text-transform: uppercase; /* Convert text to uppercase */\n  font-weight: bold; /* Make the text bold */\n}\n\n.fc .fc-button:disabled {\n  background-color: #fafafa;\n  color: black;\n  font-weight: 600;\n}\n\n/* Style the buttons in the FullCalendar header */\n.fc-toolbar .fc-button {\n  background-color: #fafafa; /* Background color */\n  color: #71717a; /* Text color */\n  border-color: #fff; /* Border color */ /* Transition for hover and click */\n  border-radius: 8px;\n  margin-right: 5px;\n  border: none;\n}\n\n.fc-toolbar .fc-button::first-letter {\n  text-transform: uppercase;\n}\n\n.fc-event:hover {\n  background-color: #cb9c2d; /* Set the desired background color on hover */\n  color: white; /* Set the desired text color on hover */\n  border-color: #cb9c2d; /* Set the desired border color on hover */\n}\n\n.fc-list-event-time,\n.fc-list-event-graphic {\n  display: none;\n}\n.fc .fc-popover {\n  z-index: 999 !important;\n}\n.fc .fc-list-event:hover td {\n  background-color: #cb9c2d !important; /* Set the desired background color on hover */\n  color: white !important; /* Set the desired text color on hover */\n  border-color: #cb9c2d !important; /* Set the desired border color on hover */\n}\n\n.fc-dayGridMonth-button.fc-button.fc-button-primary.fc-button-active {\n  background-color: #cb9c2d; /* Selected background color */\n  color: white; /* Selected text color */\n  border-radius: 8px;\n  border: none;\n}\n.fc-timeGridWeek-button.fc-button.fc-button-primary.fc-button-active {\n  background-color: #cb9c2d; /* Selected background color */\n  color: white; /* Selected text color */\n  border-radius: 8px;\n  border: none;\n}\n.fc-timeGridDay-button.fc-button.fc-button-primary.fc-button-active {\n  background-color: #cb9c2d; /* Selected background color */\n  color: white; /* Selected text color */\n  border-radius: 8px;\n  border: none;\n}\n.fc-listMonth-button.fc-button.fc-button-primary.fc-button-active {\n  background-color: #cb9c2d; /* Selected background color */\n  color: white; /* Selected text color */\n  border-radius: 8px;\n  border: none;\n}\n\n.fc .fc-toolbar-title {\n  color: #5f6d7e;\n  font-weight: 600;\n  font-size: 22px;\n}\n.fc-toolbar .fc-button:hover {\n  background-color: #e6e6e6;\n  color: black;\n}\n\n.event-dot {\n  display: flex;\n  align-items: center;\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  background-color: red;\n  border-radius: 50%;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: \"Source Sans Pro, sans-serif\";\n}\n\n.event-dot span {\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n  margin-left: 4px;\n}\n\n.tooltip {\n  position: absolute;\n  background-color: white;\n  border: 1px solid #ccc;\n  /* padding: 10px; */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  z-index: 9999; /* Set a high z-index value to bring the tooltip to the forefront */\n  font-family: \"Source Sans Pro, sans-serif\";\n  font-size: 14px;\n  display: none;\n  margin-top: 30px;\n  margin-left: 20px;\n}\n\n/* Add styles for the rows and dots within the tooltip */\n.tooltip .row {\n  display: flex;\n  align-items: center;\n  margin: 5px 0;\n  color: #4d4e4e;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.tooltip .dot {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.tooltip .title {\n  font-weight: 600;\n  font-size: 16px;\n  margin-top: -4px;\n  color: #4d4d4d;\n}\n\n.rbc-allday-cell {\n  display: none;\n}\n.rbc-row-resource {\n  height: 40px;\n}\n.rbc-row-resource .rbc-header {\n  font-size: 18px;\n  margin-top: 7px;\n}\n\n.rbc-current-time-indicator {\n  border: none !important;\n  background-color: transparent !important;\n}\n.rbc-timeslot-group {\n  background-color: #ffffff;\n}\n/* Sample CSS for styling the custom DatePicker component */\n.custom-date-picker {\n  width: 200px; /* Adjust the width as needed */\n}\n\n.custom-input {\n  display: flex;\n  align-items: center;\n}\n\n.custom-date-input {\n  flex: 1;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n  color: #5f6d7e;\n  font-weight: 500;\n}\n\n.calendar-icon {\n  margin-left: 8px;\n  cursor: pointer;\n  color: #5f6d7e;\n  font-size: 16px;\n}\n\n/* DatePicker styles */\n.react-datepicker {\n  font-family: \"Arial, sans-serif\";\n}\n.custom-calendar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  background-color: #ffffff; /* Adjust background color as needed */\n  border-bottom: 1px solid #d1d9e2; /* Add a border at the bottom */\n}\n\n.custom-calendar-title {\n  font-weight: bold;\n  font-size: 20px; /* Adjust font size as needed */\n  color: #5f6d7e;\n  font-weight: 600;\n}\n\n.custom-calendar-buttons button {\n  background-color: #f4f4f5;\n  border: none;\n  cursor: pointer;\n  margin-left: 10px;\n  transition: color 0.3s ease;\n}\n\n.default-btn {\n  width: 120px;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 35px;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: -0.016px;\n  background: #cb9c2d;\n  color: #fff;\n  margin-top: 20px;\n}\n\n.default-btn:hover {\n  background-color: #9b7725;\n}\n\n.default-city-container {\n  margin-bottom: 20px;\n}\n\n.calendar-sidebar-container {\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  width: 270px;\n}\n\n.option-container {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 5px;\n}\n\n.default-city-option {\n  appearance: none;\n  background-color: transparent;\n  border: 1px solid #cb9c2d;\n  border-radius: 50%;\n  cursor: pointer;\n  height: 16px;\n  margin: 0px;\n  padding: 0px;\n  position: relative;\n  width: 16px;\n}\n\n.default-city-option:checked {\n  background-color: transparent;\n}\n.default-city-option:checked::before {\n  background-color: #cb9c2d;\n  border-radius: 64px;\n  content: \"\";\n  height: 12px;\n  position: absolute;\n  width: 12px;\n  top: 1.5px;\n  left: 1px;\n}\n\n.date-select-calendar {\n  background-color: #ffffff;\n  border-color: #f2f0f0;\n  border-width: 2px;\n  border-style: solid;\n  font-size: 16px;\n  font-weight: 400;\n  color: #3c4147;\n  font-family: Inter;\n  border-radius: 4px;\n  padding: 5px 10px;\n  height: 38px;\n  border: 1px solid #c1c6cc;\n  box-shadow: none;\n  box-sizing: border-box;\n}\n\n.busyWrapper {\n  height: 100vh;\n  width: 100%;\n  position: fixed;\n  background-color: rgb(0, 0, 0, 0.7);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  left: 0;\n  top: 0;\n}\n\n.busyContainer {\n  width: 50%;\n  height: 85vh;\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 20px 40px;\n  box-sizing: border-box;\n}\n\n.modalContent {\n  height: calc(100% - 100px);\n  box-sizing: border-box;\n}\n\n.busyBtn {\n  height: 100px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.btnOk {\n  height: 50px;\n  width: 200px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  font-family: \"Inter\";\n  font-weight: 600;\n  line-height: 22px;\n  cursor: pointer;\n  color: #ffffff;\n  background-color: #cb9c2d;\n  box-sizing: border-box;\n}\n\n.btnOk:hover {\n  background-color: #b08726;\n}\n\n.busyItem {\n  font-size: 15px;\n  font-family: \"Inter\";\n  font-weight: 500;\n  line-height: 22px;\n  cursor: pointer;\n  color: #373636;\n  height: 40px;\n  width: 100%;\n  box-shadow: 0px 0px 30px 5px rgba(95, 109, 126, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0px 10px;\n  border-radius: 6px;\n  box-sizing: border-box;\n}\n\n.busyContent {\n  padding: 10px 0px;\n}\n\n.busyTitle {\n  width: 100%;\n  text-align: center;\n  font-family: \"Inter\";\n  font-weight: 600;\n  font-size: 32px;\n  color: #4d4d4d;\n}\n\n.loadingContainer {\n  height: 150vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 10000000;\n}\n\n@media screen and (max-width: 1300px) {\n  .sidebar-box {\n    flex-direction: column;\n    margin-top: 70px !important;\n  }\n  .calendar-sidebar-container {\n    flex-direction: row;\n    width: auto;\n    gap: 16px;\n  }\n  .selectCal {\n    min-width: 150px;\n  }\n}\n\n@media screen and (max-width: 950px) {\n  .fc .fc-view-harness {\n    overflow: scroll;\n  }\n  .fc2 {\n    margin: 50px 0px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .fc .fc-toolbar {\n    display: grid;\n    grid-template-rows: 1fr 1fr;\n    grid-template-columns: 1fr 1fr;\n    row-gap: 15px;\n  }\n\n  .fc-toolbar .fc-toolbar-chunk {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .fc .fc-toolbar .fc-toolbar-chunk:first-child {\n    grid-column: 2 / 3;\n    grid-row: 1/2;\n  }\n  .fc .fc-toolbar .fc-toolbar-chunk:nth-child(2) {\n    grid-column: 1 / 2;\n    grid-row: 1/2;\n  }\n  .fc-toolbar .fc-toolbar-chunk:last-child {\n    grid-column: 1 / 3;\n    grid-row: 2/3;\n  }\n  .fc-toolbar-chunk:last-child .fc-button-group {\n    gap: 60px;\n  }\n}\n\n@media screen and (max-width: 660px) {\n  .fc-toolbar-chunk:last-child .fc-button-group {\n    gap: 40px;\n  }\n}\n\n@media screen and (max-width: 540px) {\n  .fc-toolbar-chunk:last-child .fc-button-group {\n    gap: 25px;\n  }\n\n  .fc .fc-toolbar-title {\n    font-size: 16px;\n  }\n  .fc .fc-button {\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-width: 430px) {\n  .fc-toolbar-chunk:last-child .fc-button-group {\n    gap: 25px;\n  }\n  .fc .fc-toolbar-title {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
